import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Card, CardActions, CardContent, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from "@material-ui/core";

import { useDispatch, useSelector } from "react-redux";
import { getCredenciales } from "../../../actions/webAfiliado/afiliadoVariosAction";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import { getMotivosBaja, getTurnosAfiliado } from "../../../actions/webAfiliado/afiliadoTurnosAction";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule';
import moment from "moment";
import AfiliadoTurnosService from '../../../services/AfiliadoTurnosService'
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import { startAlerta } from "../../../actions/ui/alertas";
import { Link } from "react-router-dom";
import { ESTADISTICAS_OSPEDYC, MOTIVO_TURNOS } from "../../../utils/constants";
import { capitalize } from "../../../helpers/randoms";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold",
        marginBottom: "1rem"
    },
    containerCard: {
        paddingRight: "1rem",
        paddingLeft: "1rem"
    },
    cardIn: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: "outset",
        borderTopWidth: "thick",
        marginRight: "1rem",
        marginLeft: "1rem",
        marginBottom: "1rem",
        borderRadius: 10,
    },
    titleCard: {
        fontWeight: "bold",
        fontSize: 14,
        marginTop: "0.75rem"
    },
    containerHourDate: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "0.75rem"
    },
    hourDate: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 5,
        marginLeft: 5
    },
    colorIcons: {
        color: theme.palette.info.main
    }
}));

const MisTurnos = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const { credenciales } = useSelector(state => state.afiliadoVarios)
    const { misTurnos, motivosBaja } = useSelector(state => state.afiliadoTurnos)

    const [open, setOpen] = useState(false)
    const [idTurnoCancelar, setIdTurnoCancelar] = useState(false)



    const handleCancelar = async () => {
        try {
            dispatch(startSpinner())
            const data = {
                idAgenda: idTurnoCancelar,
                idMotivoCancelacion: MOTIVO_TURNOS.CANCELADO_POR_AFILIADO,//id
                esAfiliado: true
            }
            const result = await AfiliadoTurnosService.cancelarTurno(data)
            const body = await result.json()
            if (result.ok) {
                dispatch(getCredenciales())
                dispatch(finishSpinner())
                dispatch(startAlerta("Turno cancelado exitosamente", "success"))

            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error) {
                dispatch(startAlerta(error, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error al cancelar el turno. Intente nuevamente.", "error"))
            }
            console.log("Error al cancelar el turno", error)
        }
    }
    useEffect(() => {
        dispatch(getCredenciales())
        dispatch(getMotivosBaja())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.TURNOS))
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (credenciales !== null) {
            dispatch(getTurnosAfiliado(credenciales))
        }
        // eslint-disable-next-line
    }, [credenciales])

    if (credenciales === null || motivosBaja === null) {
        return <LoadingBeforeViewData />
    }

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Mis turnos</Typography>
                <Grid container className={classes.container}>
                    <Grid item xs={12}>
                        {
                            misTurnos.length === 0
                                ?
                                <Typography align="center">No contás con turnos programados. Para solicitar uno, haz clic <Link to="/afiliado/turnos/sacar-turno">aquí</Link></Typography>
                                :
                                <Grid container style={{ marginTop: "1rem" }}>
                                    {
                                        misTurnos.map(turno => {
                                            return (
                                                <React.Fragment key={turno.idAgenda}>
                                                {
                                                    misTurnos.length === 1 &&
                                                    <Grid item xs={null} md={3} />
                                                }
                                                <Grid item xs={12} md={6} className={classes.containerCard}>
                                                    <Card variant="outlined" className={classes.cardIn}>
                                                        <CardContent style={{ textAlign: "center" }}>
                                                            <Typography color="primary" className={classes.titleCard}>Nombre completo</Typography>
                                                            <Typography>{credenciales.find(e => e.idAfiliado === turno.idAfiliado).apellidoYNombre}</Typography>

                                                            <Typography color="primary" className={classes.titleCard}>Especialidad</Typography>
                                                            <Typography>{turno.especialidad.descripcionEspecialidades}</Typography>

                                                            <Typography color="primary" className={classes.titleCard}>Centro médico</Typography>
                                                            <Typography>{turno.centroMedico.descripcionCentro}</Typography>

                                                            <Typography color="primary" className={classes.titleCard}>Profesional</Typography>
                                                            <Typography>{turno.efectorRed.nombreEfector}</Typography>

                                                            {
                                                                turno.idTipoTurnoSol !== 3 &&
                                                                <>
                                                                    <Typography color="primary" className={classes.titleCard}>Modalidad</Typography>
                                                                    {
                                                                        turno.idTipoTurnoSol === 1
                                                                            ?
                                                                            <Typography>Presencial</Typography>
                                                                            :
                                                                            <Typography>Teleconsulta</Typography>
                                                                    }
                                                                </>

                                                            }

                                                            <div className={classes.containerHourDate}>
                                                                <div className={classes.hourDate}>
                                                                    <CalendarTodayIcon className={classes.colorIcons} />
                                                                    <Typography>{`${capitalize(moment(turno.fecha).format("dddd DD"))} de ${moment(turno.fecha).format("MMMM")}`}</Typography>
                                                                </div>
                                                                <div className={classes.hourDate}>
                                                                    <ScheduleIcon className={classes.colorIcons} />
                                                                    <Typography>{turno.hora}</Typography>
                                                                </div>
                                                            </div>
                                                        </CardContent>
                                                        <CardActions style={{ justifyContent: "center" }}>
                                                            <Button size="small" color="primary" variant="contained" onClick={() => {
                                                                setIdTurnoCancelar(turno.idAgenda)
                                                                setOpen(true)
                                                            }}>Cancelar</Button>
                                                        </CardActions>
                                                    </Card>
                                                </Grid>
                                                {
                                                    misTurnos.length === 1 &&
                                                    <Grid item xs={null} md={3} />
                                                }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </Grid>
                        }
                    </Grid>
                    <Dialog
                        open={open}
                        onClose={() => setOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogTitle id={"alert-dialog-title"}>Cancelación de turno</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <Typography style={{ marginBottom: "1rem" }}>¿Estás seguro de que deseas cancelar el turno?</Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpen(false)} color="secondary" autoFocus>Cancelar</Button>
                            <Button onClick={() => {
                                    setOpen(false)
                                    handleCancelar()
                            }} color="primary" autoFocus>Aceptar</Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Container>
        </div>
    );
};

export default MisTurnos
